module.exports = __webpack_public_path__ + "e9546ed0f8b003a34d85eb5475cd1b69.png";


//////////////////
// WEBPACK FOOTER
// ./assets/panacek-rest.png
// module id = F6cP
// module chunks = 0